import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["sx", "variant", "color"];
import PropTypes from 'prop-types';
import * as React from 'react';
import MuiButton from '@mui/material/Button';
import { ButtonGroupContext } from '../ButtonGroup';
import { extendSX } from '../helpers';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Demos:
 *
 * - [Button](https://ui-packages.isbuildingluma.com/ui-core/react-button/)
 *
 * API:
 *
 * - [Button API](https://ui-packages.isbuildingluma.com/ui-core/api/button/)
 * - inherits [MuiButton API](https://mui.com/material-ui/api/button/)
 */
const Button = /*#__PURE__*/React.forwardRef(function Button(_ref, ref) {
  let {
      sx,
      variant: variantProp = 'text'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const contextProps = React.useContext(ButtonGroupContext);

  // https://www.figma.com/file/WJDRbOCCrGVDTsbUC3yvp8/Luma-Design-System?type=design&node-id=3-633&t=xjk30hb38Yp5chEw-0
  const props = React.useMemo(() => {
    let color = 'inherit';
    if (variantProp === 'primary' || contextProps.variant === 'primary') {
      color = 'primary';
    } else if (variantProp === 'danger') {
      color = 'error';
    }
    const variant = variantProp === 'text' && !contextProps.variant ? 'text' : 'contained';
    return {
      variant,
      color
    };
  }, [variantProp, contextProps.variant]);
  return /*#__PURE__*/_jsx(MuiButton, _extends({
    ref: ref,
    sx: extendSX(sx)
  }, contextProps, props, rest));
});
process.env.NODE_ENV !== "production" ? Button.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit "ButtonProps.ts" and run "yarn proptypes"
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOf(['danger', 'primary', 'secondary', 'text'])
} : void 0;
export default Button;